/* COLOR Palette
Primary - Tufts Blue: #5089C6 rgb(80, 137, 198)
Seconday - Marigold: #f3a712 rgb(243, 167, 18)
Complimentary1 - Firey Rose: #f56476 rgb(245, 100, 118)
Complitentary2 - Russian Green: #739e82 rgb(115, 158, 130)
Light - White: #FFFFFF rgb(255, 255, 255)
Dark - Gunmetal: #232c33 rgb(35, 44, 51)
*/

 export const ColorPaletteHex = {
    primary: '#5089C6',
    secondary: '#f3a712',
    complimentary1: '#f56476',
    complimentary2: '#739e82',
    light: '#FFFFFF',
    dark: '#232c33'
}

export const ColorPaletteRGB = {
    primary: 'rgb(80, 137, 198)',
    secondary: 'rgb(243, 167, 18)',
    complimentary1: 'rgb(245, 100, 118)',
    complimentary2: 'rgb(115, 158, 130)',
    light: 'rgb(255, 255, 255)',
    dark: 'rgb(35, 44, 51)'
}

